import React, { Component } from "react";
import { observer } from "mobx-react";
import { Accessor, ColorX, DownloadX, GFunc, LocaleX, NavX, ReqX, ZTime, ZValidate } from "IZOX/STATIC";
// eslint-disable-next-line no-unused-vars
import PropsType from "prop-types";
import { HStack, Spacer, VStack, XButton, XText } from "IZOX/_X";
import { PageFlipper, QForm } from "IZOX/BLOCKS/Libs";
import _ from "lodash";
import QUICKUI from "shared/QUICKUI";
import ClaimRow from "shared/ClaimRow";
import PIContainer from "../shared/PIContainer/PIContainer";
import ViewClaim from "Pages/LoggedUser/Agent/PAClaims/_gears/ViewClaim";
import { QFCheckBox, QFRadio, QFText } from "IZOX/BLOCKS/Libs/QForm/_gears";
import QFDateRange from "IZOX/BLOCKS/Libs/QForm/_gears/QFDateRange";

/**
 * @augments {Component<Props, State>}
 */
class PIClaims extends Component {

  static propTypes = {

  }

  static defaultProps = {

  }

  constructor(){
    super();
    this.state = {
      docs: [],
      selected: [],
      tab: "All",
      page: 0,
      pageSize: 5,
      search: false
    };
  }

  componentDidMount(){
    this._setAllStates(() => {
      this.GetClaims();
    });
  }

  componentDidUpdate(prevProps, prevState){
    if(!Accessor.IsIdentical(prevProps, this.props, Object.keys(PIClaims.defaultProps))){
      this._setAllStates();
    }
  }

  componentWillUnmount() {
    this.setState = (state, callback) => {
      return;
    };
  }

  _setAllStates = (callback) => {
    this.setState((state, props) => ({
      ...props,
    }), callback);
  }

  GetClaims = async () => {
    let {search} = this.state;
    if(search){
      this._toSearchSubmit();
    }else{
      this._toGet();
    }
  }

  _toGet = async () => {
    let {page, pageSize, tab} = this.state;
    let res = await ReqX.SendBE("/Web/Insurer/GetClaims", {
      status: tab === "All"? undefined : tab,
      page,
      pageSize
    });
    let {Success, payload} = res;
    if(Success){
      let {docs, count} = payload;
      this.setState({
        docs, count
      });
    }
  }

  _toSearchSubmit = async () => {
    let {tab, page, pageSize, searchForm} = this.state;
    let res = await ReqX.SendBE("/Web/Insurer/SearchClaims", {
      searchForm, 
      status: tab === "All" ? undefined : tab,
      page, pageSize
    });
    let {Success, payload} = res;
    if(Success){
      let {docs, count} = payload;
      this.setState({
        docs: docs,
        count: count,
        search: true
      });
    }
  }

  _onPageSizeChange = (pageSize) => {
    this.setState({
      pageSize: pageSize
    }, () => {
      this.GetClaims();
    });
  }

  _onPageChange = (page) => {
    this.setState({
      page: page
    }, () => {
      this.GetClaims();
    });
  }

  _toReport = (selected, isReceipt = false) => {

  }

  _onDownload = async (_id) => {
    
  }

  _onCheck = (_id) => {
    let {selected, docs} = this.state;
    if(selected.includes(_id)){
      selected = _.filter(selected, o => o !== _id);
    }else{
      selected.push(_id);
    }

    let selectedAllForm = {
      selectAll: false
    };
    if(selected.length === docs.length){
      selectedAllForm = {
        selectAll: true
      };
    }
    this.setState({
      selected: selected,
      selectedAllForm: selectedAllForm
    });
  }

  _toToggleCheckAll = (selectedAllForm) => {
    let {docs} = this.state;
    let {selectAll} = selectedAllForm;
    let _selected = selectAll ? _.map(docs, o => o._id) : [];
    this.setState({
      selected: _selected,
      selectedAllForm: selectedAllForm
    });
  }

  _toTab = (tab) => {
    this.setState({
      tab: tab,
      page: 0
    }, () => {
      this.GetClaims();
    });
  }

  PopupClaim = async (docID) => {
    let res = await ReqX.SendBE("/Web/Insurer/ViewClaim", {
      docID
    });
    let {Success, payload} = res;
    if(Success){
      GFunc.Backdrop(() => {
        return (
          <ViewClaim doc={payload}/>
        );
      }, {}, false);
    }else{
      GFunc.Alert(payload, "error");
    }
  }

  renderClaimDoc(doc, idx){
    let {selected} = this.state;
    let {_id} = doc;
    return (
      <ClaimRow claimDoc={doc} key={idx}
        checked={selected.includes(_id)}
        onCheck={() => this._onCheck(_id)}
        onDownload={() => this._onDownload(_id)}
        onViewDetailPress={() => this.PopupClaim(doc._id)}/>
    );
  }

  _toPage = (page) => {
    let {history} = this.props;
    NavX.Goto(history, page);
  }

  onMountQForm = (callbacks) => {
    this.MountQForm = callbacks;
  }

  onFormChange = (formValue) => {
    this.setState({
      searchForm: formValue
    });
  }

  _toClearSearch = () => {
    this.setState({
      searchForm: {},
      search: false
    }, () => {
      this.MountQForm?.Clear();
      this.GetClaims();
    });
  }

  _toSearch = () => {
    this.setState({
      page: 0,
      search: true
    }, () => {
      this.GetClaims();
    });
  }

  renderPageTab(url, label, here = false){
    return (
      <XButton onPress={() => this._toPage(url)} round={0}
        padding={16}
        fullWidth
        bgColor={ColorX.CSS(here ? "Leaf" : "Gray4")} color={ColorX.CSS("pureWhite")}>
        <HStack>
          <XText bold fontSize={14}>
            {LocaleX.Parse(label)}
          </XText>
        </HStack>
      </XButton>
    );
  }

  renderHeader(){
    return (
      <HStack mB={24} spacing={2}>
        {this.renderPageTab("/Insurer/AllPolicies", {
          EN: "Policies",
          TC: "保單"
        }, false)}
        {this.renderPageTab("/Insurer/Claim", {
          EN: "Claims",
          TC: "索償"
        }, true)}
      </HStack>
    );
  }

  renderTabBtn(_tab, text, extraStyle, idx){
    let {tab} = this.state;
    let isTab = tab === _tab;
    return (
      <XButton color={ColorX.CSS(isTab? "pureWhite" : "Gray4")}
        bgColor={ColorX.CSS(isTab ? "Axit" : "pureWhite")}
        fitWidthToContent zIndex={isTab ? 15 : 10 - idx}
        mL={idx === 0 ? 0 : -10} mT={10}
        padding={10} pH={15}
        onPress={() => this._toTab(_tab)}
        style={{
          ...extraStyle,
          minWidth: 150,
          borderRadius: "10px 10px 0px 0px",
          boxShadow: `0px 2px 2px 2px ${ColorX.CSS("greyOut", 0.5)}`
        }}>
        <HStack>
          <XText fontSize={14}>
            {LocaleX.Parse(text)}
          </XText>
        </HStack>
      </XButton>
    );
  }

  renderClaimTabs(){
    let {selectedAllForm} = this.state;
    return (
      <HStack HAlign="[">
        {this.renderTabBtn("All", {EN: "All", TC: "全部"}, {}, 0)}
        {this.renderTabBtn("Submitted", {EN: "Submitted", TC: "已提交"}, {}, 1)}
        {this.renderTabBtn("Approved", {EN: "Approved", TC: "已核准"}, {}, 2)}
        {this.renderTabBtn("Declined", {EN: "Declined", TC: "已拒絕"}, {}, 3)}
        {this.renderTabBtn("Completed", {EN: "Completed", TC: "已完成"}, {}, 4)}
        <Spacer/>
        <QForm onChange={this._toToggleCheckAll} value={selectedAllForm}>
          <HStack spacing={10} fitWidthToContent>
            <QFCheckBox name="selectAll"
              bColor={ColorX.CSS("pureWhite")} size={16}
              bgColor={ColorX.CSS("pureWhite")} color={ColorX.CSS("Axit")} />
            <XText color={ColorX.CSS("Axit")}>
              {LocaleX.Parse({
                EN: "Check all",
                TC: "勾選全部"
              })}
            </XText>
          </HStack>
        </QForm>
      </HStack>
    );
  }

  renderClaimList(){
    let {docs, page, pageSize, count} = this.state;
    if(docs.length === 0){
      return QUICKUI.NoDocs({
        EN: "There is no claims.",
        TC: "沒有任何索償紀錄。"
      });
    }
    return (
      <VStack fullWidth>
        {_.map(docs, (o, i) => {
          return this.renderClaimDoc(o, i);
        })}
        <PageFlipper totalDocs={count} 
          page={page}
          pageSize={pageSize}
          onPageSizeChange={this._onPageSizeChange}
          onPageChange={this._onPageChange}
          popupPosition="top" 
          mainColor={ColorX.CSS("Axit")} />
      </VStack>
    );
  }

  renderTextField(name, label, readOnly = false){
    let {userDoc} = this.state;
    let value = Accessor.Get(userDoc, name);
    return (
      <VStack fullWidth>
        <HStack HAlign="[" spacing={4}>
          <XText fontSize={12} color={ColorX.CSS("Stone")}>
            {LocaleX.Parse(label)}
          </XText>
        </HStack>
        <QFText name={name} placeholder={LocaleX.Parse({
          EN: "Search ",
          TC: "搜尋 "
        }) + LocaleX.Parse(label).toLowerCase()} disabled={readOnly}
          defaultValue={value}
          p={12}
          focus_bColor={ColorX.CSS("Axit")}
          bColor={ColorX.CSS("Gray5")}/>
      </VStack>
    );
  }

  renderSearchForm(){
    let {search, searchForm} = this.state;
    return (
      <QForm fullWidth p={16} bgColor={ColorX.CSS("pureWhite")}
        value={searchForm} onMounted={this.onMountQForm}
        spacing={24} onChange={this.onFormChange}>
        <HStack spacing={24}>
          <VStack fullWidth>
            <HStack HAlign="[" spacing={4}>
              <XText fontSize={12} color={ColorX.CSS("Stone")}>
                {LocaleX.Parse({
                  EN: "Apply date",
                  TC: "申請日期"
                })}
              </XText>
            </HStack>
            <QFDateRange name={"period"}
              p={12}
              bW={1}
              height={44}
              focus_bColor={ColorX.CSS("Axit")}
              bColor={ColorX.CSS("Gray5")}
              placeholder={LocaleX.Parse({
                EN: "Search apply date",
                TC: "搜尋申請日期"
              })}/>
          </VStack>
          {this.renderTextField("policyNo", 
            {
              EN: "Policy number / Insurance certificate No.",
              TC: "保單號碼 / 保險憑證號碼"
            })}
        </HStack>
        <HStack>
          <XButton onPress={this._toClearSearch} fullWidth
            color={ColorX.CSS("Axit")}>
            <HStack>
              <XText bold>
                {LocaleX.Parse({
                  EN: "Reset",
                  TC: "重置"
                })}
              </XText>
            </HStack>
          </XButton>
          <XButton onPress={this._toSearch} padding={0} pV={5} fullWidth
            color={ColorX.CSS(search ? "pureWhite" : "Axit")} 
            bgColor={ColorX.CSS(search ? "Axit" : "pureWhite")} 
            style={{borderColor: ColorX.CSS("Axit")}}
            bW={1} round={50}>
            <HStack>
              <XText bold>
                {LocaleX.Parse({
                  EN: "Search",
                  TC: "搜尋"
                })}
              </XText>
            </HStack>
          </XButton>
        </HStack>
      </QForm>
    );
  }

  renderBulkBtn(label, func){
    let {selected} = this.state;
    return (
    <XButton onPress={func} fitWidthToContent padding={8}
      disabled={!selected || selected?.length === 0}
        pH={15} round={50} bW={1}
        bColor={ColorX.CSS("Axit")}
        color={ColorX.CSS("Axit")}>
        <HStack>
          <XText fontSize={12}>
            {LocaleX.Parse({
              EN: `${label?.EN ?? label} (${selected?.length})`,
              TC: `${label?.TC ?? label} (${selected?.length})`
            })}
          </XText>
        </HStack>
      </XButton>
    );
  }

  renderClaimHeader(){
    let {selected, count} = this.state;
    return (
      <HStack spacing={20}>
        <XText bold>
          {LocaleX.Parse({
            EN: `List claims (${count ?? 0})`,
            TC: `索償清單 (${count ?? 0})`
          })}
        </XText>
        <Spacer/>
        {this.renderBulkBtn({
          EN: "Download claims",
          TC: "下載索償"
        }, () => this._toReport(selected))}
      </HStack>
    );
  }

  renderClaims(){
    return (
      <VStack fullWidth mT={20}>
        {this.renderClaimHeader()}
        {this.renderClaimTabs()}
        {this.renderClaimList()}
      </VStack>
    );
  }

  _onReportChange = (fv) => {
    this.setState({
      reportForm: fv
    });
  }

  _genReport = async () => {
    let {reportForm} = this.state;
    this.setState({
      loading: true
    }, async () => {
      let res = await ReqX.SendBEAndGetBlob("/Web/Insurer/GenerateXSLX", {
        ...reportForm,
      });
      this.setState({
        loading: false
      });
      let { Success, blob } = res;
      if (Success) {

        let prefix = "Report_";
        switch(reportForm?.type){
          default: break;
          case "claim_withPayment": prefix = "Claim report (with payment)_"; break;
          case "claim_withoutPayment": prefix = "Claim report (without payment)_"; break;
        }

        DownloadX.Excel(blob, prefix + ZTime.Moment(reportForm.month).format("YYYY.MM"));
      };
    });
  }

  renderReportGenerate(){
    let {reportForm} = this.state;
    return (
      <QForm mB={20} fullWidth value={reportForm} onChange={(fv) => this._onReportChange(fv)}>
        <HStack HAlign="[" fullWidth pH={16} pV={10} bgColor={ColorX.CSS("pureWhite")}>
          {QUICKUI.WebDateField("month", {
            EN: "Report Month",
            TC: "報告月份"
          }, {
            dateType: "month",
            maxDate: ZTime.Now().toISOString()
          })}
          <HStack spacing={20} HAlign="[" height={50} pH={30} fitWidthToContent>
            <HStack spacing={10} width={180} HAlign="[">
              <QFRadio name="type" refValue={"claim_withPayment"} 
                bColor={ColorX.CSS("Axit")}/>
                <XText color={ColorX.CSS("Stone")}>
                  {LocaleX.Parse({
                    EN: "With payment",
                    TC: "有付款"
                  })}
                </XText>
            </HStack>
            <HStack spacing={10} width={180} HAlign="[">
              <QFRadio name="type" refValue={"claim_withoutPayment"} 
                bColor={ColorX.CSS("Axit")}/>
              <XText color={ColorX.CSS("Stone")}>
                {LocaleX.Parse({
                  EN: "Without payment",
                  TC: "無付款"
                })}
              </XText>
            </HStack>
          </HStack>
          <XButton onPress={this._genReport} padding={0} pH={20} pV={5} fitWidthToContent
            disabled={!ZValidate.CheckAllFields(reportForm, ["month", "type"], ["required"])}
            color={ColorX.CSS("pureWhite")} 
            bgColor={ColorX.CSS("Axit")} 
            style={{borderColor: ColorX.CSS("Axit")}}
            bW={1} round={50}>
            <HStack fitWidthToContent>
              <XText bold>
                {LocaleX.Parse({
                  EN: "Generate",
                  TC: "生成報告"
                })}
              </XText>
            </HStack>
          </XButton>
        </HStack>
      </QForm>
    );
  }

  render(){
    return (
      <PIContainer>
        <VStack bgColor={ColorX.CSS("NotQuiteWhite")} fullWidth
          p={16}>
            {this.renderHeader()}
            {this.renderReportGenerate()}
            {this.renderSearchForm()}
            {this.renderClaims()}
        </VStack>
      </PIContainer>
    );
  }

}

export default observer(PIClaims);
